// eslint-disable-next-line no-restricted-exports
export { useResetIconStyle as default } from '../../theme/internal';
